/* @flow */
import * as React from 'react';

import Text from 'components/Text.jsx';

type Props = {
  title: ?React.Element<any>,
  subtext: ?React.Element<any>,
  titleWeight: ?('semibold' | 'normal'),
};

function TextWithSubtextCell({ title, subtext, titleWeight }: Props) {
  return (
    <React.Fragment>
      {title && (
        <Text
          lineHeight={subtext ? 'xlarge' : 'medium'}
          size="small"
          weight={titleWeight || 'normal'}
          element="div">
          {title}
        </Text>
      )}
      {subtext && (
        <Text size="xxsmall" color="thunder" element="div">
          {subtext}
        </Text>
      )}
    </React.Fragment>
  );
}

export function getTextWithSubtextCellGenerator(
  titleFieldName: string,
  subtextFieldName: string,
  options?: { titleWeight?: 'semibold' | 'normal' }
) {
  return (data: Object) => {
    return (
      <TextWithSubtextCell
        title={data[titleFieldName]}
        subtext={data[subtextFieldName]}
        titleWeight={options ? options.titleWeight : undefined}
      />
    );
  };
}
